/* eslint-disable camelcase */
import React, { useState, useEffect } from "react";
import {
  fetchExperience,
  // fetchExperienceMock,
} from "../../services/client";
import { MARKER_TYPES } from "../../constants";
import { isMobile } from "../../utils/ResponsiveUtils";

const isDesktop = !isMobile();

const parseMobileStartData = ({
  mobile_intro_portrait_button_label,
  mobile_intro_portrait_button_font,
  mobile_intro_portrait_button_font_color,
  mobile_intro_portrait_button_background_color,
  mobile_intro_portrait_background_image_url,
  mobile_intro_portrait_background_image_alt_text,
}) => {
  return {
    button: {
      text: mobile_intro_portrait_button_label,
      font: mobile_intro_portrait_button_font,
      color: mobile_intro_portrait_button_font_color,
      bgColor: mobile_intro_portrait_button_background_color,
    },
    background: {
      backgroundUrl: mobile_intro_portrait_background_image_url,
      backgroundAltText: mobile_intro_portrait_background_image_alt_text || "",
    },
  };
};

const parseMobileIntroData = ({
  mobile_intro_show,
  mobile_intro_title_show,
  mobile_intro_title,
  mobile_intro_title_font,
  mobile_intro_title_color,
  mobile_intro_subtitle_show,
  mobile_intro_subtitle,
  mobile_intro_subtitle_font,
  mobile_intro_subtitle_color,
  mobile_byline_show,
  mobile_byline,
  mobile_byline_font,
  mobile_byline_color,
  mobile_intro_button_label,
  mobile_intro_button_font,
  mobile_intro_button_color,
  mobile_intro_button_background_color,
  mobile_intro_button_icon_alt_text,
  mobile_intro_button_icon_url,
  mobile_intro_background_image_alt_text,
  mobile_intro_background_image_url,
}) => {
  return {
    showIntro: mobile_intro_show,
    title: {
      text: mobile_intro_title || "",
      font: mobile_intro_title_font,
      color: mobile_intro_title_color,
      show: mobile_intro_title_show,
    },
    subtitle: {
      text: mobile_intro_subtitle || "",
      font: mobile_intro_subtitle_font,
      color: mobile_intro_subtitle_color,
      show: mobile_intro_subtitle_show,
    },
    byline: {
      text: mobile_byline || "",
      font: mobile_byline_font,
      color: mobile_byline_color,
      show: mobile_byline_show,
    },
    introBtn: {
      text: mobile_intro_button_label,
      font: mobile_intro_button_font,
      color: mobile_intro_button_color,
      bgColor: mobile_intro_button_background_color,
      iconUrl: mobile_intro_button_icon_url,
      iconAltText: mobile_intro_button_icon_alt_text || "",
    },
    background: {
      backgroundUrl: mobile_intro_background_image_url,
      backgroundAltText: mobile_intro_background_image_alt_text || "",
    },
  };
};

const parseDesktopIntroData = ({
  desktop_intro_show,
  desktop_intro_title_show,
  desktop_intro_title,
  desktop_intro_title_font,
  desktop_intro_title_color,
  desktop_intro_subtitle_show,
  desktop_intro_subtitle,
  desktop_intro_subtitle_font,
  desktop_intro_subtitle_color,
  desktop_byline_show,
  desktop_byline,
  desktop_byline_font,
  desktop_byline_color,
  desktop_intro_button_label,
  desktop_intro_button_font,
  desktop_intro_button_color,
  desktop_intro_button_background_color,
  desktop_intro_button_icon_alt_text,
  desktop_intro_button_icon_url,
  desktop_intro_background_image_alt_text,
  desktop_intro_background_image_url,
}) => {
  return {
    showIntro: desktop_intro_show,
    title: {
      text: desktop_intro_title || "",
      font: desktop_intro_title_font,
      color: desktop_intro_title_color,
      show: desktop_intro_title_show,
    },
    subtitle: {
      text: desktop_intro_subtitle || "",
      font: desktop_intro_subtitle_font,
      color: desktop_intro_subtitle_color,
      show: desktop_intro_subtitle_show,
    },
    byline: {
      text: desktop_byline || "",
      font: desktop_byline_font,
      color: desktop_byline_color,
      show: desktop_byline_show,
    },
    introBtn: {
      text: desktop_intro_button_label,
      font: desktop_intro_button_font,
      color: desktop_intro_button_color,
      bgColor: desktop_intro_button_background_color,
      iconUrl: desktop_intro_button_icon_url,
      iconAltText: desktop_intro_button_icon_alt_text || "",
    },
    background: {
      backgroundUrl: desktop_intro_background_image_url,
      backgroundAltText: desktop_intro_background_image_alt_text || "",
    },
  };
};

const parseMobileOutroData = ({
  mobile_outro_title_show,
  mobile_outro_title,
  mobile_outro_title_font,
  mobile_outro_title_color,
  mobile_outro_subtitle_show,
  mobile_outro_subtitle,
  mobile_outro_subtitle_font,
  mobile_outro_subtitle_color,
  mobile_outro_replay_button_show,
  mobile_outro_replay_button_label,
  mobile_outro_replay_button_background_color,
  mobile_outro_replay_button_label_font,
  mobile_outro_replay_button_label_color,
  mobile_outro_replay_button_icon_alt_text,
  mobile_outro_replay_button_icon_url,
  mobile_outro_logo_url,
  mobile_outro_logo_alt_text,
  mobile_outro_background_image_url,
  mobile_outro_background_image_alt_text,
}) => ({
  title: {
    text: mobile_outro_title,
    font: mobile_outro_title_font,
    color: mobile_outro_title_color,
    show: mobile_outro_title_show,
  },
  subtitle: {
    text: mobile_outro_subtitle,
    font: mobile_outro_subtitle_font,
    color: mobile_outro_subtitle_color,
    show: mobile_outro_subtitle_show,
  },
  logo: {
    url: mobile_outro_logo_url,
    altText: mobile_outro_logo_alt_text,
  },
  background: {
    url: mobile_outro_background_image_url,
    altText: mobile_outro_background_image_alt_text,
  },
  replayBtn: {
    show: mobile_outro_replay_button_show,
    text: mobile_outro_replay_button_label,
    font: mobile_outro_replay_button_label_font,
    color: mobile_outro_replay_button_label_color,
    bgColor: mobile_outro_replay_button_background_color,
    icon: {
      url: mobile_outro_replay_button_icon_url,
      altText: mobile_outro_replay_button_icon_alt_text,
    },
  },
});

const parseDesktopOutroData = ({
  desktop_outro_title_show,
  desktop_outro_title,
  desktop_outro_title_font,
  desktop_outro_title_color,
  desktop_outro_subtitle_show,
  desktop_outro_subtitle,
  desktop_outro_subtitle_font,
  desktop_outro_subtitle_color,
  desktop_outro_replay_button_show,
  desktop_outro_replay_button_label,
  desktop_outro_replay_button_background_color,
  desktop_outro_replay_button_label_font,
  desktop_outro_replay_button_label_color,
  desktop_outro_replay_button_icon_alt_text,
  desktop_outro_replay_button_icon_url,
  desktop_outro_logo_url,
  desktop_outro_logo_alt_text,
  desktop_outro_background_image_url,
  desktop_outro_background_image_alt_text,
}) => ({
  title: {
    text: desktop_outro_title,
    font: desktop_outro_title_font,
    color: desktop_outro_title_color,
    show: desktop_outro_title_show,
  },
  subtitle: {
    text: desktop_outro_subtitle,
    font: desktop_outro_subtitle_font,
    color: desktop_outro_subtitle_color,
    show: desktop_outro_subtitle_show,
  },
  logo: {
    url: desktop_outro_logo_url,
    altText: desktop_outro_logo_alt_text,
  },
  background: {
    url: desktop_outro_background_image_url,
    altText: desktop_outro_background_image_alt_text,
  },
  replayBtn: {
    show: desktop_outro_replay_button_show,
    text: desktop_outro_replay_button_label,
    font: desktop_outro_replay_button_label_font,
    color: desktop_outro_replay_button_label_color,
    bgColor: desktop_outro_replay_button_background_color,
    icon: {
      url: desktop_outro_replay_button_icon_url,
      altText: desktop_outro_replay_button_icon_alt_text,
    },
  },
});

const parseMarkerType = (markerType) => {
  let parsedType = null;
  switch (markerType) {
    case "show_navigation":
      parsedType = MARKER_TYPES.SHOW_NAV;
      break;
    case "hide_navigation":
      parsedType = MARKER_TYPES.HIDE_NAV;
      break;
    case "show_skip_button":
      parsedType = MARKER_TYPES.SHOW_SKIP;
      break;
    case "hide_skip_button":
      parsedType = MARKER_TYPES.HIDE_SKIP;
      break;

    default:
      break;
  }
  return parsedType;
};

const parseMarkers = (markersArr) =>
  markersArr.map((marker) => {
    return { type: parseMarkerType(marker.type), mark: marker.time };
  });

const parseFeatures = (experienceFeatures) =>
  experienceFeatures.map((feature) => ({
    title: feature.title,
    start: feature.start_time,
    end: feature.end_time,
    iconUrl: feature.icon_url,
    iconAltText: feature.icon_alt_text,
    markers: parseMarkers(feature.feature_markers),
  }));

const parseProgressbar = (barColor) => ({ color: barColor });

const parsePlayerControls = ({
  nav_active_home_icon_url,
  nav_active_home_icon_alt_text,
  nav_play_icon_url,
  nav_play_icon_alt_text,
  nav_pause_icon_alt_text,
  nav_pause_icon_url,
  desktop_home_button_show,
  mobile_home_button_show,
}) => ({
  homeBtn: {
    url: nav_active_home_icon_url,
    altText: nav_active_home_icon_alt_text,
    show: isDesktop ? desktop_home_button_show : mobile_home_button_show,
  },
  playBtn: {
    url: nav_play_icon_url,
    altText: nav_play_icon_alt_text,
  },
  pauseBtn: {
    url: nav_pause_icon_url,
    altText: nav_pause_icon_alt_text,
  },
});

const parseDemo = (dataToParse) => {
  const {
    video_thumbnail_url,
    sizzle_start,
    sizzle_end,
    sizzle_has,
    sizzle_show_desktop,
    show_features,
    streaming_url,
    video_original_content_type,
    video_original_url,
    features,
    nav_progress_bar_indicator_color,
    audio_track_url,
    alternative_audio_track_url,
    desktop_intro_show,
    mobile_intro_show,
    desktop_outro_show,
    mobile_outro_show,
  } = dataToParse;
  return {
    hasSizzle: sizzle_has,
    showSizzle: sizzle_show_desktop,
    sizzle: {
      start: sizzle_start,
      end: sizzle_end,
    },
    showFeatures: show_features && true,
    videoUrl: streaming_url || video_original_url || "",
    videoType:
      (!streaming_url || streaming_url === ""
        ? video_original_content_type
        : "") || "",
    videoPoster: video_thumbnail_url || "",
    audioTrack: audio_track_url,
    alternativeAudioTrack: alternative_audio_track_url,
    features: parseFeatures(features),
    playerControls: parsePlayerControls(dataToParse),
    progressBar: parseProgressbar(nav_progress_bar_indicator_color),
    hasOutro: isDesktop ? desktop_outro_show : mobile_outro_show,
    hasIntro: isDesktop ? desktop_intro_show : mobile_intro_show,
  };
};

const parseRotateIndicator = ({ labels }) => {
  const rotateLabel = labels.find(
    (label) => label.name === "rotate_your_device"
  );
  return {
    text:
      typeof rotateLabel !== "undefined"
        ? rotateLabel.text
        : "Please rotate your label",
  };
};

const parseData = (dataToParse) => ({
  product: {
    name: dataToParse.product_name,
  },
  start: isDesktop ? null : parseMobileStartData(dataToParse),
  intro: isDesktop
    ? parseDesktopIntroData(dataToParse)
    : parseMobileIntroData(dataToParse),
  outro: isDesktop
    ? parseDesktopOutroData(dataToParse)
    : parseMobileOutroData(dataToParse),
  demo: parseDemo(dataToParse),
  rotateIndicator: parseRotateIndicator(dataToParse),
});

const Wrapper = (WrappedComponent) => {
  return function WrapperFn(props) {
    const [parsedData, setParsedData] = useState({});

    // Load data from network
    useEffect(() => {
      const fetchExpData = async () => {
        try {
          const { apiUrl, experienceId } = document.getElementById(
            "irobot-embedded-interactive-experience"
          ).dataset;

          const { data: fetchedData } = await fetchExperience(
            apiUrl,
            experienceId,
          );

          // Keep this in case mock data is needed to test
          // const { data: fetchedData } = await fetchExperienceMock(
          //   apiUrl,
          //   experienceId,
          // );

          setParsedData(parseData(fetchedData));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error.toString());
        }
      };
      fetchExpData();
      return () => {};
    }, []);

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <WrappedComponent data={parsedData} {...props} />;
  };
};

export default Wrapper;
